import {reduxForm, Field} from 'redux-form'

const inputField = (field) => {
  return (
    <div>
      <input {...field.input}
        type={field.type || 'text'}
        maxLength={field.maxLength}
        className='form-control'
        placeholder={field.placeholder}
        readOnly={field.readOnly}
        />
      <small className='error'>{field.meta.touched ? field.meta.error : ''}</small>
    </div>
  )
}

const validate = (values) => {
  const errors = {}
  let {password, confirmPassword} = values
  if (!password) {
    errors.password = 'This field is required'
  } else if (password.length < 6) {
    errors.password = 'Please Enter at least 6 Characters'
  }
  if (!confirmPassword) {
    errors.confirmPassword = 'This field is required'
  } else if (confirmPassword !== password) {
    errors.confirmPassword = 'Please enter the same value again.'
  }
  return errors
}

class ConfirmEmployeeForm extends React.Component {
  render () {
    let {handleSubmit} = this.props
    return (
      <form onSubmit={handleSubmit}>
        <div className='row'>
          <div className='col-sm-12 form-group'>
            <hr />
            <Field
              component={inputField}
              placeholder='First Name'
              name='firstName'
              maxLength='40'
              readOnly='true'
            />
            <Field
              component={inputField}
              placeholder='Last Name'
              name='lastName'
              maxLength='40'
              readOnly='true'
            />
            <Field
              component={inputField}
              placeholder='Email'
              name='email'
              maxLength='40'
              readOnly='true'
            />
            <Field
              component={inputField}
              placeholder='Password'
              name='password'
              type='password'
              maxLength='40'
            />
            <Field
              component={inputField}
              placeholder='Confirm Password'
              name='confirmPassword'
              type='password'
              maxLength='40'
            />
            <button
              type='submit'
              className='btn btn-primary pull-left'>
              Create Employee Account
            </button>
          </div>
        </div>
      </form>
    )
  }
}

const mapFormValidation = {
  form: 'confirmEmployeeForm',
  touchOnBlur: false,
  touchOnChange: true,
  validate
}

export default reduxForm(mapFormValidation)(ConfirmEmployeeForm)



// WEBPACK FOOTER //
// ./app/pages/ConfirmEmployee/ConfirmEmployeeForm.js